export default {
  // center:require('../assets/images/center.gif'),
  // normal_bg:require('../assets/images/normal_bg.png'),
  // normal_title:require('../assets/images/normal_title.png'),
  // sensitive_bg:require('../assets/images/sensitive_bg.png'),
  // sensitive_title:require('../assets/images/sensitive_title.png')
}



// WEBPACK FOOTER //
// ./src/utils/img.js